import { render, staticRenderFns } from "./CredentialsUpload.vue?vue&type=template&id=aaca19e8&scoped=true&"
import script from "./CredentialsUpload.vue?vue&type=script&lang=ts&"
export * from "./CredentialsUpload.vue?vue&type=script&lang=ts&"
import style0 from "./CredentialsUpload.vue?vue&type=style&index=0&id=aaca19e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaca19e8",
  null
  
)

export default component.exports